import React from 'react';

export const Wordpress = ({ width = 24, height = 24, ...props }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            role="img"
            {...props}
        >
            <g clipPath="url(#clip0_2136_57322)">
                <path
                    d="M40 20C40 8.96 31.04 0 20 0C8.96 0 9.30699e-08 8.96 2.07745e-07 20C3.22421e-07 31.04 8.96 40 20 40C31.04 40 40 31.04 40 20ZM20 2.02C29.94 2.02 37.98 10.06 37.98 20C37.98 29.94 29.94 37.98 20 37.98C10.06 37.98 2.02 29.94 2.02 20C2.02 10.06 10.06 2.02 20 2.02ZM16.02 29.64L9.92 13.22C10.9 13.16 12.02 13.06 12.02 13.06C12.88 12.96 12.78 11.04 11.9 11.08C11.9 11.08 9.32 11.28 7.64 11.28C7.34 11.28 6.98 11.28 6.6 11.26C9.48 6.92 14.4 4.06 20 4.06C24.18 4.06 27.98 5.64 30.82 8.24C29.62 8.08 27.92 8.94 27.92 11.08C27.92 12.4 28.68 13.52 29.5 14.84C30.12 15.92 30.5 17.28 30.5 19.26C30.5 21.94 27.96 28.22 27.96 28.22L22.54 13.22C23.5 13.16 24.04 12.9 24.04 12.9C24.9 12.8 24.8 10.7 23.94 10.74C23.94 10.74 21.34 10.96 19.66 10.96C18.1 10.96 15.44 10.74 15.44 10.74C14.58 10.7 14.48 12.86 15.34 12.9L17.02 13.06L19.26 19.14L16.02 29.64ZM28.06 33.94L33.28 20C33.28 20 34.62 16.62 34.06 12.38C35.32 14.66 35.94 17.22 35.94 20C35.94 25.92 32.82 31.16 28.06 33.94ZM5.36 13.54L13 34.5C7.66 31.9 4.06 26.34 4.06 20C4.06 17.68 4.46 15.54 5.36 13.54ZM20.26 22.6L24.84 35.1C23.34 35.64 21.7 35.94 20 35.94C18.56 35.94 17.18 35.72 15.88 35.34L20.26 22.6Z"
                    fill="currentColor"
                />
            </g>
            <defs>
                <clipPath id="clip0_2136_57322">
                    <rect width="40" height="40" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
